<template>
  <div class="col-12 col-lg-6">
    <div class="blog-list-wrapper">
      <div class="blog-list-item d-flex">
        <img class="blog-list-item__image" :src="`${blog.img.link}`" :alt="blog.img.alt">
        <div class="d-flex flex-column justify-content-between">
          <h3 class="h4">{{ blog.title }}</h3>
          <div>
            <RectAngleShape class="mb-3" />
            <p>{{ blog.date }}</p>
            <ButtonTransparent :text="blog.button.text" hyperlink :href="blog.button.link" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ButtonTransparent from '../common/ButtonTransparent.vue';
import RectAngleShape from '../common/RectAngleShape.vue';


export default {
    components: { RectAngleShape, ButtonTransparent },
    props: {
        blog: {
            id: String,
            img: {
                link: {
                  initialUrl: String,
                  altText: String,
                }
            },
            title: String,
            date: String,
            button: {
                text: String,
                link: String,
            },
        },
    }
}
</script>
